import React from 'react';
import { IConfigurableCar, IStockCar } from '../../../../interfaces/Car';
import { isBrandAP } from '../../../../constants/main';

export const renderCarName = ({ model, engine, bodyStyle, specPack, gearbox, displayGrBodyStyleLabel }: IConfigurableCar | IStockCar) => {

    return (
        <div className="carInfoHeader">
            <div>
                <h2 className="car-title">
                    {!isBrandAP && (
                        <>
                            <span>
                                {model.title} {displayGrBodyStyleLabel && bodyStyle.title}
                            </span>{' '}
                        </>
                    )}
                    <span className="title-specPack">{specPack.title}</span>
                </h2>
                <span className="title-engineInfo">
                    {engine.title} {gearbox.title}{' '}
                </span>
            </div>
        </div>
    );
};
